import script from "./ConnectFriends.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectFriends.vue?vue&type=script&setup=true&lang=js"

import "./ConnectFriends.vue?vue&type=style&index=0&id=9f0b9d60&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f0b9d60"]])

export default __exports__